import { render, staticRenderFns } from "./ProofreadingEditor.vue?vue&type=template&id=22253c50&scoped=true"
import script from "./ProofreadingEditor.vue?vue&type=script&lang=ts"
export * from "./ProofreadingEditor.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingEditor.vue?vue&type=style&index=0&id=22253c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22253c50",
  null
  
)

export default component.exports